import axios from 'axios';

axios.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  // Telegram injects signed init data in the Mini App; a plain browser gets none, so a string from
  // `yarn dev-token` stands in. Both are the same credential verified the same way — the server has
  // no separate development path to authenticate through.
  const initData =
    Telegram?.WebApp?.initData || process.env.REACT_APP_DEV_INIT_DATA;
  if (initData) {
    config.headers['Authorization'] = window.btoa(initData);
  }
  return config;
});
